export default {
  trackingProxyBaseUrl: "https://consumer.arc-net.io/api/tracking-data",
  blockchainProxyBaseUrl: "https://consumer.arc-net.io/api/blockchain",
  emailSignUpUrl:
    "https://consumer.arc-net.io/api/add-to-mailing-list?brand=adelphi",
};
